import { motion } from "framer-motion";
import { PRODUCTS } from "@/constants/testIds";

const products = [
  {
    slug: "engagement-rings",
    title: "Engagement Rings",
    caption: "Solitaires, halos & bespoke commissions",
    image:
      "https://images.pexels.com/photos/15871523/pexels-photo-15871523.jpeg?auto=compress&cs=tinysrgb&w=1400",
    span: "md:col-span-8 md:row-span-2",
    ratio: "aspect-[4/5]",
  },
  {
    slug: "gold-silver-rings",
    title: "Gold and Silver Jewellery",
    caption: "Everyday sculptural bands",
    image:
      "https://images.unsplash.com/photo-1602509380108-a47060db0a97?auto=format&fit=crop&w=1000&q=80",
    span: "md:col-span-4",
    ratio: "aspect-[4/5]",
  },
  {
    slug: "necklaces",
    title: "Necklaces",
    caption: "Chain-work, pendants & rivières",
    image:
      "https://images.unsplash.com/photo-1620656798579-1984d9e87df7?auto=format&fit=crop&w=1000&q=80",
    span: "md:col-span-4",
    ratio: "aspect-[4/5]",
  },
  {
    slug: "earrings",
    title: "Earrings",
    caption: "Studs, hoops & drops",
    image:
      "https://images.unsplash.com/photo-1475179593777-bd12fd56b85d?auto=format&fit=crop&w=1000&q=80",
    span: "md:col-span-4",
    ratio: "aspect-[3/4]",
  },
  {
    slug: "bracelets",
    title: "Bracelets",
    caption: "Bangles, tennis & cuffs",
    image:
      "https://images.pexels.com/photos/34399145/pexels-photo-34399145.jpeg?auto=compress&cs=tinysrgb&w=1000",
    span: "md:col-span-4",
    ratio: "aspect-[3/4]",
  },
  {
    slug: "watches",
    title: "Watches",
    caption: "Restored & new — mechanical only",
    image:
      "https://images.pexels.com/photos/7339212/pexels-photo-7339212.jpeg?auto=compress&cs=tinysrgb&w=1000",
    span: "md:col-span-4",
    ratio: "aspect-[3/4]",
  },
];

export default function Products() {
  return (
    <section
      id="collections"
      data-testid={PRODUCTS.section}
      className="relative bg-[#F7F5F2] px-6 md:px-10 pt-32 pb-32"
    >
      <div className="flex items-end justify-between border-b border-[#1C1C1A]/10 pb-8 mb-12">
        <div>
          <p className="text-[10px] uppercase tracking-[0.32em] font-sans text-[#1C1C1A]/70 mb-4">
            Ch. 04 — The Collections
          </p>
          <h2 className="font-serif font-light leading-[0.95] text-5xl md:text-7xl lg:text-8xl tracking-[-0.02em]">
            Up to 60% off
            <br />
            <span className="italic text-[#9A8B73]">on engagement rings.</span>
          </h2>
        </div>
        <a
          href="https://www.instagram.com/diamant_jewellers?igsh=MWMwdDI4YTVubWQ0bQ=="
          target="_blank"
          rel="noreferrer noopener"
          className="hidden md:inline-flex link-underline text-xs uppercase tracking-[0.24em] font-sans"
        >
          Check our Instagram for designs →
        </a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
        {products.map((p, i) => (
          <motion.a
            key={p.slug}
            href="#contact"
            data-testid={PRODUCTS.card(p.slug)}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{
              duration: 0.9,
              delay: i * 0.05,
              ease: [0.16, 1, 0.3, 1],
            }}
            className={`group product-frame relative overflow-hidden ${p.span} ${p.ratio} block bg-[#E5D5C1]/40`}
          >
            <img
              src={p.image}
              alt={p.title}
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            {/* dark clipped strip overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#1C1C1A]/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            <div className="absolute left-0 right-0 bottom-0 p-5 md:p-6 flex items-end justify-between text-[#F7F5F2]">
              <div>
                <p className="text-[10px] uppercase tracking-[0.3em] font-sans opacity-80">
                  {String(i + 1).padStart(2, "0")} — House
                </p>
                <h3 className="font-serif text-2xl md:text-3xl mt-1 leading-none">
                  {p.title}
                </h3>
                <p className="mt-2 text-xs font-sans opacity-80 max-w-[220px]">
                  {p.caption}
                </p>
              </div>
              <span
                className="inline-flex items-center justify-center w-10 h-10 border border-[#F7F5F2]/70 translate-x-1 group-hover:translate-x-0 transition-transform duration-500"
                aria-hidden="true"
              >
                →
              </span>
            </div>
          </motion.a>
        ))}
      </div>
    </section>
  );
}
